import { StackFrame } from 'stacktrace-parser';

export type CodeFrame = {
  content: string;
  location?: {
    row: number;
    column: number;
    [key: string]: any;
  };
  fileName: string;
};

export type MetroStackFrame = StackFrame & { collapse?: boolean };
export type Stack = StackFrame[];
